module.exports = __webpack_public_path__ + "static/img/witness-teens.5fcab44c.png";